import axios from 'axios';

class Request {
    constructor(options) {

        this.headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (_.has(options, 'headers')) {
            this.headers = Object.assign(this.headers, options.headers)
        }

        let vm = this;

        this.instance = axios.create({
            baseURL: _.has(options, 'baseURL') ? options.baseURL : '/',
            timeout: _.has(options, 'timeout') ? options.timeout : 0,
            headers: vm.headers,
            validateStatus: function (status) {
                return status >= 200 && status < 300;
            },
        });

    }

    make(url, method = 'get', data = {}) {

        if (_.has(data, 'headers')) {
            delete data.headers;
        }

        return this.instance[method](url, Request.prepareSendData(method, data));

    }

    static prepareSendData(method, data) {

        if (!['get'].includes(method)) {
            return data;
        }

        if (Object.keys(data).length > 0 && !_.has(data, 'params')) {
            return {
                params: data
            }
        }

        return data;
    }

}

export default Request;
